import { Component } from "@angular/core";
import { BaseComponent } from "@schabu/web.angular/components";

@Component({
	imports: [],
	selector: "sbu-footer",
	templateUrl: "./footer.component.html"
})
export class SchabuFooterComponent extends BaseComponent {
	constructor() {
		super();
	}

	protected override preDestroy(): void {}
	protected override postDestroy(): void {}
	protected override preInit(): void {}
	protected override postInit(): void {}
}